module.exports = __webpack_public_path__ + "img/sankaku_53_blue.b908b752.png";